const hasParentheses = (decayType) => {
    if (!decayType) {
        return false;
    }

    return decayType.includes('(') || decayType.includes(')');
} ;

export default hasParentheses;
